/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable react/destructuring-assignment */
import React, { InputHTMLAttributes } from 'react';
import { FormWrapper, Label, Input } from './styles';

interface IMFAInput extends InputHTMLAttributes<HTMLInputElement> {
  label: string;
}

const MFAInput: React.FC<IMFAInput> = props => (
  <FormWrapper>
    <Label>{props.label}</Label>
    <Input {...props} />
  </FormWrapper>
);

export default MFAInput;
